import React, {Component} from 'react';
import {Link, hashHistory} from 'react-router';
import {inject, observer} from 'mobx-react';
import {DropDownMenu, IconMenu, MenuItem, IconButton, AppBar} from 'material-ui';
import Header from './Header'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Home from 'material-ui/svg-icons/action/home';

import {observable} from 'mobx';

@inject('dataSourceStore', 'unitStore')
@observer
class App extends Component {

  @observable selectedOrigin = '-1';
  @observable selectedSource = null;

  onChangeSelectedOrigin = (e, i, v) => {
    this.selectedOrigin = v;
    this.selectedSource = null;
  };
  setSelectedSource = code => this.selectedSource = code;
  onClickHome = () => {
    this.selectedSource = null;
    hashHistory.push('/');
  };

  componentWillMount() {
    this.props.dataSourceStore.fetch();
    this.props.unitStore.fetch();
  }
// <li key={origin.id} onClick={() => this.setSelectedSource(origin.code)}>
// <Link to={`/dataSource/${dataOrigin.id}/${origin.id}`}>
// <ul>{origin.stations && origin.stations.map(station => <li>{station.name}</li>)}</ul>
// </Link>
// </li>
  render() {
    const {dataSourceStore, children} = this.props;
    let dataOrigin = dataSourceStore.findById(this.selectedOrigin);

    return (
      <div className="inline-it" style={{padding: '0px'}}>
        <div className="hierarchy" style={{padding: '0px'}}>
          <Header style={{height: '60px', padding: '0px'}}>
            <DropDownMenu value={this.selectedOrigin} labelStyle={{color: 'white'}}
                          onChange={this.onChangeSelectedOrigin}>
              <MenuItem value="-1" primaryText="Select Origin"/>{
              dataSourceStore.items.length > 0 && dataSourceStore.items.map(item => (
                <MenuItem key={item.id} value={item.id} primaryText={item.name}/>
              ))
            }</DropDownMenu>
          </Header><br/>
          <ul className="hierarchy-content">{
            dataOrigin && dataOrigin.origins && dataOrigin.origins.map(origin => (
              <Link to={`/dataSource/${dataOrigin.id}/${origin.id}`} onClick={() => this.setSelectedSource(origin.code)}><details key={origin.id} open>
                <summary>{origin.code}</summary>
                <ul>{origin.stations && origin.stations.map(station => <li>{station.name}</li>)}</ul>
              </details></Link>
            ))
          }</ul>
        </div>
        <div className="main-content" style={{padding: '0px', height: '100vh', overflowY: 'scroll'}}>
          <AppBar
            title={this.selectedSource}
            iconElementLeft={<IconButton onClick={this.onClickHome}><Home/></IconButton>}
            iconElementRight={
              <IconMenu
                iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                targetOrigin={{horizontal: 'left', vertical: 'top'}}
              >
                {/*<MenuItem primaryText={'Set TSS'}/>*/}
                <MenuItem primaryText={'Log Out'} onClick={() => hashHistory.push('logout')}/>
              </IconMenu>
            }
          />
          {children? React.cloneElement(children, { dataOrigin }): null}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js